import { Chip, Stack } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PushPinIcon from '@mui/icons-material/PushPin';

interface StatusChipsProps {
    typeLabel?: string;
    isFixed?: boolean;
    isDefault?: boolean;
    isVisible?: boolean;
    isPublished?: boolean;
}

export function StatusChips({ typeLabel, isFixed, isDefault, isVisible, isPublished }: StatusChipsProps) {
    return (
        <Stack direction="row" spacing={0.75} sx={{ flexWrap: 'wrap', rowGap: 0.5 }}>
            {typeLabel && <Chip size="small" color="primary" variant="outlined" label={typeLabel} />}
            {isFixed && <Chip size="small" icon={<PushPinIcon />} label="Fixa" />}
            {isDefault && <Chip size="small" icon={<LockIcon />} label="Padrão" />}
            {isVisible === false && <Chip size="small" color="warning" variant="outlined" icon={<VisibilityOffIcon />} label="Oculto" />}
            {isPublished !== undefined && (
                <Chip size="small" color={isPublished ? 'success' : 'default'} label={isPublished ? 'Publicada' : 'Rascunho'} />
            )}
        </Stack>
    );
}
